// extracted by mini-css-extract-plugin
module.exports = {"comp":"ActivityA1_comp__VWJQj"};